export * from './src/angular2-esri4.module';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
